import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import { Autocomplete, TextField } from "@mui/material";

export const CultivoSelect = ({ name, value, onChange }) => {
    // Opciones manuales
    const opcionesCultivo = [
        "Consolidado",
        "Sin cultivo seleccionado",
        "Maíz grano",
        "Mango",
        "Garbanzo",
        "Frijol",
        "Chile verde",
        "Caña de azúcar",
        "Agave",
        "Tomate rojo",
        "Sorgo grano",
        "Pepino",
        "Tomate verde",
        "Naranja",
        "Limón",
        "Sandía",
        "Berenjena",
        "Papaya",
        "Aguacate",
        "Alfalfa",
        "Durazno",
        "Calabacita",
        "Elote",
        "Cebolla",
        "Toronja",
        "Nopalitos",
        "Guayaba",
        "Café cereza",
        "Arroz palay",
        "Tabaco",
        "Plátano",
        "Piña",
        "Maíz forrajero en verde",
        "Sorgo forrajero en verde",
        "Melón",
        "Uva",
        "Lechuga",
        "Ajonjolí",
        "Jicama"
    ];

    return (
        <Autocomplete
            options={opcionesCultivo}
            value={value || ""}
            onChange={(e, newValue) =>
                onChange({ target: { name, value: newValue || "" } })
            }
            getOptionLabel={(option) => option}
            isOptionEqualToValue={(option, value) => option === value}
            disableClearable
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder="Seleccione cultivo"
                    variant="outlined"
                    sx={{
                        "& .MuiOutlinedInput-root": {
                            borderRadius: "5px",
                            border: "1px solid #2d682d",
                            backgroundColor: "#f7f7f7",
                            color: "#2d682d",
                            marginBottom: "10px",
                            height: "26px",
                            padding: "0",
                            "& input": {
                                padding: "0 8px 2px 8px",
                                fontSize: "0.85rem",
                                color: "#2d682d",
                                lineHeight: "1.1rem",
                                position: "relative",
                                top: "-4px",
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                            },
                            "&:hover": {
                                border: "1px solid #2d682d",
                            },
                            "&.Mui-focused": {
                                border: "1px solid #2d682d",
                                boxShadow: "0 0 0 2px rgba(45,104,45,0.15)",
                            },
                        },
                    }}
                />
            )}
            sx={{
                width: "100%",
                "& .MuiAutocomplete-popupIndicator": {
                    color: "#2d682d",
                    padding: "0",
                    fontSize: "0.9rem",
                    right: "-6px",
                    top: "3px",
                },
                "& .MuiAutocomplete-endAdornment": {
                    right: "-2px",
                },
            }}
        />
    );
};
